import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { NavigationCancel, NavigationEnd, NavigationError, NavigationStart, Router } from '@angular/router';
import { filter } from 'rxjs';
import { AuthServiceService } from './services/auth-service.service';
import { NotificationCountService } from './services/notification-count.service';
import { LoaderService } from './services/loader.service';
import { WebsocketnotificationService } from './services/websocketnotification.service';
import { ShareddtaService } from './services/shareddta.service';
import { ConnectivityService } from './services/connectivity.service';
import { BreadcrumbService, BreadcrumbItem } from './services/breadcrumb.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit {
  title = 'RealTimeTrac';
  isLoggedIn: boolean = false;
  notificationsInitialized = false;
  loading = false;
  routeLoading = false;
  isOffline = false;
  breadcrumbItems: BreadcrumbItem[] = [];

  constructor(private router: Router, public authService: AuthServiceService, private notificationCountService: NotificationCountService, loader: LoaderService, public websocketnotification: WebsocketnotificationService, private shareddta: ShareddtaService, private connectivityService: ConnectivityService, private breadcrumbService: BreadcrumbService) {
    this.websocketnotification.connectWebSocket();
    loader.loading$.subscribe(v => this.loading = v);
    this.isLoggedIn = localStorage.getItem('isLoggedIn') === 'true' && !!localStorage.getItem('access_token');
    this.router.events.subscribe(event => {
      if (event instanceof NavigationStart) {
        // Extract primary path (strip query params, fragments, secondary outlets)
        const targetPath = event.url.split('?')[0].split('#')[0].split('(')[0];
        const currentPath = this.router.url.split('?')[0].split('#')[0].split('(')[0];

        // Only show route loader if the primary path is actually changing AND
        // it is not a page that manages its own loading state (dialogs, etc.)
        const isSamePage = targetPath === currentPath;
        const isNoLoaderPage = event.url.includes('locate-driver') || event.url.includes('analytics') || event.url.includes('/driver') || event.url.includes('/profile');

        if (!isSamePage && !isNoLoaderPage) {
          this.routeLoading = true;
        }
      } else if (event instanceof NavigationEnd) {
        this.routeLoading = false;
        // Reset content area scroll position to top on navigation
        const contentArea = document.querySelector('.content-area');
        if (contentArea) {
          contentArea.scrollTo(0, 0);
        }
      } else if (
        event instanceof NavigationCancel ||
        event instanceof NavigationError
      ) {
        this.routeLoading = false;
      }
    });

  }

  get isLocateDriverPage(): boolean {
    return window.location.href.includes('locate-driver') || this.router.url.includes('locate-driver');
  }

  get isNoSpinnerPage(): boolean {
    const url = this.router.url;
    return url.includes('locate-driver') || url.includes('/profile') || url.includes('dispatch-sheet') || url.includes('bulk-order');
  }

  ngOnInit() {
    this.breadcrumbService.items$.subscribe(items => {
      this.breadcrumbItems = items;
    });
    this.shareddta.fetchCountryCode();
    this.shareddta.pageReady$.subscribe(() => {
      this.routeLoading = false;
    });

    this.connectivityService.onlineStatus$.subscribe((isOnline: boolean) => {
      this.isOffline = !isOnline;
    });
    this.authService.getDashboard().subscribe((data: any) => {
      this.isLoggedIn = data;
    const roleChanged = localStorage.getItem('isroleChanged');

if (roleChanged) {
  this.notificationsInitialized = roleChanged === 'true';
  localStorage.removeItem('isroleChanged');
}
      if (this.isLoggedIn === true && !this.notificationsInitialized) {
        this.notificationCountService.triggerRefresh();
        this.notificationsInitialized = true;
      }
      if (!this.isLoggedIn) {
        this.notificationsInitialized = false;
      }
      const subscriptionStatus = localStorage.getItem('subscription_status');
      if (subscriptionStatus === 'expired') {
        this.isLoggedIn = false;
      }
    });
    const saved = localStorage.getItem('sidebarState');
    if (saved !== null) {
      this.sidebarCollapsed = saved === 'true';
    }
  }
  readFromLocalStorage(): void {
    this.isLoggedIn = localStorage.getItem('isLoggedIn') === 'true' && !!localStorage.getItem('access_token');
  }
  sidebarCollapsed = true;

  toggleSidebar(): void {
    this.sidebarCollapsed = !this.sidebarCollapsed;
    localStorage.setItem('sidebarState', this.sidebarCollapsed.toString());
  }

  onFilterChange(filterValue: string): void {
    console.log('Filter changed:', filterValue);
    // Implement filter logic
    // You can emit this to a service or use a state management solution
  }

  onDateChange(date: string): void {
    console.log('Date changed:', date);
    // Implement date filter logic
  }
  notificationCountData: any;

  notificationCount() {
    this.authService.notificationCount().subscribe((res) => {
      this.notificationCountData = res?.result?.num_unread;
      this.notificationCountService.setCount(this.notificationCountData);
    });
  }

  notificationShipping() {
    this.authService.notificationShippingCount().subscribe({
      next: (res) => {
        this.notificationCountData = res?.result?.num_unread ?? 0;
        this.notificationCountService.setCount(this.notificationCountData);
      },
      error: (err) => {
        console.error("notificationShipping error:", err);
        this.notificationCountData = 0;
        this.notificationCountService.setCount(0);
      }
    });
  }

  notificationReciver() {
    this.authService.notificationReciverCount().subscribe({
      next: (res) => {
        this.notificationCountData = res?.result?.num_unread ?? 0;
        this.notificationCountService.setCount(this.notificationCountData);
      },
      error: (err) => {
        console.error("notificationReciver error:", err);
        this.notificationCountData = 0;
        this.notificationCountService.setCount(0);
      }
    });
  }
}
